import axiosClient from "../api/axiosClient";

export const sendAiChatMessage = ({
  message,
  conversationId = null,
  screenName = "PromoterPanel",
  eventId = null,
  languageCode = "en",
}) =>
  axiosClient.post("/ai/chat", {
    message,
    conversationId,
    screenName,
    eventId,
    languageCode,
  });

export const sendAiFeedback = ({ messageId, rating, comment = null }) =>
  axiosClient.post("/ai/feedback", {
    messageId,
    rating,
    comment,
  });

export const getAiConversations = () => axiosClient.get("/ai/conversations");

export const getAiConversation = (id) =>
  axiosClient.get(`/ai/conversations/${id}`);

export const getAiSuggestedQuestions = (languageCode = "en") =>
  axiosClient.get("/ai/suggested-questions", {
    params: { languageCode },
  });
